import type {BioIconProps} from '../common-types'

export function DiscountRibbon({fill = '#EA413B', text, ...attributes}: BioIconProps) {
  return (
    <svg width="107" height="107" viewBox="0 0 107 107" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.88379 84.2131C2.17741 87.9922 0.115544 93.9178 0 98.4181V51.3805C0 48.21 1.25903 45.17 3.50119 42.9288L23.2144 23.2145L42.9286 3.5012C45.1698 1.25904 48.2098 0 51.3803 0H98.4187C93.9175 0.115545 87.9928 2.17742 84.2127 5.88381L45.0493 45.0484L5.88379 84.2131Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.1641 2.9891H106.159C104.008 1.09158 101.238 0.0297651 98.3549 0.00585938C95.2342 0.0974982 91.4521 1.1364 88.1641 2.9891Z"
        fill="#8A1915"
      />
      <mask id="mask0_5897_12975" maskUnits="userSpaceOnUse" x="0" y="88" width="3" height="19">
        <path d="M0.00390625 88.166H2.98813V106.162H0.00390625V88.166Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5897_12975)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.98813 88.166V106.162C1.09062 104.011 0.028808 101.24 0.00390625 98.3578C0.0955447 95.2361 1.13544 91.4541 2.98813 88.166Z"
          fill="#8A1915"
        />
      </g>
      <text
        x="40"
        y="25"
        fill="white"
        fontSize="16"
        fontWeight="400"
        fontFamily="Helvetica"
        textAnchor="middle"
        transform="rotate(-45 55 35)"
      >
        {text}
      </text>
    </svg>
  )
}
